// extracted by mini-css-extract-plugin
export var messagingContainer = "styles-module__messagingContainer___ZwROv";
export var form = "styles-module__form___QwFu4";
export var phone = "styles-module__phone___AGM2m";
export var button = "styles-module__button___q4vKK";
export var disabled = "styles-module__disabled___kDB1_";
export var loading = "styles-module__loading___k0VV8";